'use strict';

var _ = require('lodash');
function FlightSummaryDataTransformerService(momentService, userActionService, bookingsIntakeTransformer, transformerHelper, dataRetrieverService, dataRetrieverConstants, userService, dtdFilteringService, featureToggleService) {
  function initializeDistinctClassNames(resources) {
    var distinctInventoryControls = _.reduce(resources, function (distinctInventoryControls, resource) {
      return _.unionBy(distinctInventoryControls, resource.inventoryControls, 'className');
    }, []);
    return _.map(distinctInventoryControls, _.partialRight(_.pick, 'className'));
  }
  function filterOutDtdsOutsideSearchCriteria(legCabins) {
    var metricDescriptor = dataRetrieverService.getDataRetriever(dataRetrieverConstants.FLIGHT_SCREEN, dataRetrieverConstants.CABIN_MODE).getMetricDescriptor();
    var dtdCriteria = metricDescriptor && metricDescriptor.params && metricDescriptor.params.dtdCriteria;
    return dtdCriteria && dtdCriteria.length ? dtdFilteringService.filterByDtd(legCabins, dtdCriteria) : legCabins;
  }
  function transform(restApiResponse, controlType) {
    var result = [];
    var filteredLegCabins = filterOutDtdsOutsideSearchCriteria(restApiResponse.resources);
    var dataSize = filteredLegCabins.length;
    var memoizedMomentOfDepartureDate = _.memoize(transformerHelper.getMomentOfDate);
    var memoizedMomentOfDepartureTime = _.memoize(transformerHelper.getMomentOfTime);
    var memoizedMomentOfArrivalTime = _.memoize(transformerHelper.getMomentOfTime);
    var memoizedMomentOfEventTimeStamp = _.memoize(transformerHelper.getMomentOfDate);
    var memoizedYearMonthDayOfMoment = _.memoize(transformerHelper.getYearMonthDayOfMoment);
    var memoizedFormatUserActionList = _.memoize(userActionService.formatActionsList);
    var distinctClassNames = initializeDistinctClassNames(filteredLegCabins);
    var serviceClassControlEnabled = featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
    for (var i = 0; i < dataSize; i++) {
      var el = filteredLegCabins[i];
      var avgFare = el.currentBookings ? el.currentRevenue / el.currentBookings : undefined;
      var lastYearAvgFare = el.lastYearCurrentBookings ? el.lastYearCurrentRevenue / el.lastYearCurrentBookings : undefined;
      var flightDepartureDateMoment = memoizedMomentOfDepartureDate(el.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.TIMESTAMP);
      var actions = memoizedFormatUserActionList(el.userActionList);
      var action = actions[0];
      var newEntry = {
        flightId: el.flightId,
        flightNumber: el.flightNumber,
        legId: el.legId,
        leg: el.leg,
        legCabinId: el.legCabinId,
        equipment: el.equipment,
        carrier: el.carrier,
        referenceCurveFlightId: el.referenceCurveFlightId,
        optGroupDate: el.optGroupDate,
        sequence: el.sequence,
        season: el.season,
        dowGroup: el.dowGroup,
        daysToDeparture: el.daysToDeparture,
        cabinCode: el.cabinCode,
        physicalCapacity: el.physicalCapacity,
        lastYearCurrentCapacity: el.lastYearCurrentCapacity,
        lastYearFinalCapacity: el.lastYearFinalCapacity,
        legLoadFactor: el.legLoadFactor,
        currentLoadFactor: el.currentLoadFactor,
        lastYearCurrentLoadFactor: el.lastYearCurrentLoadFactor,
        currentRASd: el.currentRASd,
        lastYearCurrentRASd: el.lastYearCurrentRASd,
        currentRevenue: el.currentRevenue,
        lastYearCurrentRevenue: el.lastYearCurrentRevenue,
        currentBookings: el.currentBookings,
        expectedBookings: el.expectedBookings,
        lastYearCurrentBookings: el.lastYearCurrentBookings,
        numberOfAlertRulesApplied: el.numberOfAlertRulesApplied,
        groupBookings: el.groupBookings,
        lastYearGroupBookings: el.lastYearGroupBookings,
        remainingDemandFC: el.remainingDemandFC + el.mappedRemainingDemandFC,
        emsrSlack: el.emsrSlack,
        overbookingPercentEffective: el.overbookingPercentEffective,
        bidPrice: el.bidPrice,
        expectedLoadFactor: el.expectedLoadFactor,
        lastYearFinalLoadFactor: el.lastYearFinalLoadFactor,
        expectedRASd: el.expectedRASd,
        lastYearFinalRASd: el.lastYearFinalRASd,
        lastYearFinalBookings: el.lastYearFinalBookings,
        expectedRevenue: el.expectedRevenue,
        lastYearFinalRevenue: el.lastYearFinalRevenue,
        expectedYield: el.expectedYield,
        lastYearFinalYield: el.lastYearFinalYield,
        appliedRules: el.appliedRules,
        adjustments: el.adjustments,
        scenarioName: el.scenarioName,
        cabinIndex: el.cabinIndex,
        flightTags: el.flightTags ? el.flightTags.toString() : undefined,
        //calculated fields
        entryKey: el.carrier + el.leg + el.flightNumber + el.flightDepartureDate + el.cabinCode,
        flightDepartureDateMoment: flightDepartureDateMoment,
        flightDepartureDate: memoizedYearMonthDayOfMoment(flightDepartureDateMoment),
        optGroupDateMoment: memoizedMomentOfDepartureDate(el.optGroupDate, momentService.FIELD.DEPARTURE_DATE),
        legDepartureDateMoment: memoizedMomentOfDepartureDate(el.legDepartureDate, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.TIMESTAMP),
        departureDateTimeMoment: memoizedMomentOfDepartureTime(el.departureTime, momentService.FIELD.DEPARTURE_TIME, memoizedMomentOfDepartureDate),
        arrivalDateTimeMoment: memoizedMomentOfArrivalTime(el.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memoizedMomentOfDepartureDate),
        eventTimeStampMoment: memoizedMomentOfEventTimeStamp(el.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP),
        alerts: el.alertScore ? el.alertScore : 0,
        topAlert: el.topAlertName ? el.topAlertName : '',
        cabinWaitList: el.cumulativeCabinWaitList,
        avgFare: avgFare,
        lastYearAvgFare: lastYearAvgFare,
        customClasses: {
          currentLoadFactor: transformerHelper.getTrendClass(el.currentLoadFactor, el.lastYearCurrentLoadFactor),
          currentRASd: transformerHelper.getTrendClass(el.currentRASd, el.lastYearCurrentRASd),
          expectedLoadFactor: transformerHelper.getTrendClass(el.expectedLoadFactor, el.lastYearFinalLoadFactor),
          expectedRASd: transformerHelper.getTrendClass(el.expectedRASd, el.lastYearFinalRASd),
          expectedBookings: transformerHelper.getTrendClass(el.expectedBookings, el.lastYearFinalBookings),
          expectedRevenue: transformerHelper.getTrendClass(el.expectedRevenue, el.lastYearFinalRevenue),
          avgFare: transformerHelper.getTrendClass(avgFare, lastYearAvgFare)
        },
        appliedRulesNumber: _.size(el.appliedRules),
        actions: actions,
        actionType: _.get(action, 'type'),
        actionTime: _.get(action, 'time'),
        actionUser: _.get(action, 'user')
      };
      if (!serviceClassControlEnabled) {
        transformerHelper.generateInventoryControls(el.inventoryControls, distinctClassNames, newEntry, undefined, controlType);
      }
      bookingsIntakeTransformer.calculateBookingsIntake(newEntry, el);
      bookingsIntakeTransformer.calculateBookingsIntake(newEntry, el, 'performanceIntake');
      transformerHelper.generatePerformanceBookingIntakeOffsets(newEntry, newEntry.performanceIntakeData);
      result.push(newEntry);
    }
    bookingsIntakeTransformer.createBookingsIntakeHtml(result);
    return result;
  }
  function applyControlType(rows, controlType) {
    return transformerHelper.applyControlType(rows, controlType);
  }
  return {
    transform: transform,
    applyControlType: applyControlType
  };
}
FlightSummaryDataTransformerService.$inject = ['MomentService', 'UserActionService', 'BookingsIntakeTransformationService', 'FlightManagementDataRetrieverHelperService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'UserProcessingTransformationService', 'DtdFilteringService', 'FeatureToggleService'];
module.exports = FlightSummaryDataTransformerService;